import React from 'react';

import theme from '@adsk/alloy-react-theme';

interface TaskMilestoneIconProps {
  size?: number;
  color?: string;
}

const TaskMilestoneIcon = ({
  size = 17,
  color = theme.colors.charcoal500,
}: TaskMilestoneIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox={`0 0 ${size} ${size}`}
    fill="none"
  >
    <path
      d="M8.93337 17.5501C8.74107 17.5496 8.55077 17.511 8.37342 17.4366C8.19608 17.3623 8.0352 17.2535 7.90004 17.1168L0.816703 10.0334C0.54394 9.75868 0.390869 9.38723 0.390869 9.00009C0.390869 8.61294 0.54394 8.2415 0.816703 7.96675L7.90004 0.883421C8.17786 0.616561 8.54815 0.467529 8.93337 0.467529C9.31859 0.467529 9.68888 0.616561 9.9667 0.883421L17.0584 7.96675C17.194 8.10233 17.3014 8.26347 17.3744 8.44084C17.4473 8.61822 17.4844 8.8083 17.4834 9.00009C17.4847 9.19267 17.447 9.38353 17.3725 9.56113C17.2981 9.73874 17.1883 9.8994 17.05 10.0334L9.9667 17.1168C9.83154 17.2535 9.67066 17.3623 9.49332 17.4366C9.31597 17.511 9.12567 17.5496 8.93337 17.5501ZM8.93337 1.71675C8.9063 1.71672 8.87956 1.72268 8.85506 1.7342C8.83057 1.74573 8.80893 1.76254 8.7917 1.78342L1.70004 8.86675C1.66314 8.90801 1.64274 8.96141 1.64274 9.01676C1.64274 9.0721 1.66314 9.1255 1.70004 9.16675L8.78337 16.2501C8.79892 16.276 8.82091 16.2974 8.8472 16.3123C8.87348 16.3271 8.90317 16.335 8.93337 16.335C8.96357 16.335 8.99326 16.3271 9.01954 16.3123C9.04583 16.2974 9.06781 16.276 9.08337 16.2501L16.1667 9.16675C16.2036 9.1255 16.224 9.0721 16.224 9.01676C16.224 8.96141 16.2036 8.90801 16.1667 8.86675L9.08337 1.76675C9.06419 1.74606 9.041 1.72949 9.01521 1.71803C8.98943 1.70657 8.96158 1.70046 8.93337 1.70009V1.71675Z"
      fill={color}
    />
  </svg>
);

export default TaskMilestoneIcon;
